import {useLocation, useParams} from "react-router-dom";
import {useCategoryForms} from "../hooks/useCategoryForms";
import Loader from "../components/Loader";
import usePaperlessNavigate from "../hooks/usePaperlessNavigate";
import {ReactComponent as NoData} from '../assets/no_data.svg'
import {MdKeyboardBackspace} from "react-icons/md";
import {useAtom} from "jotai";
import {createFormAtom} from "../atoms/createFormAtom";
import NetworkError from "../components/NetworkError";
import Card from "../components/Card";
import {useMemo} from "react";

const CategoryForms = () => {
    const {categoryId} = useParams()
    const {data, isError, error, isLoading, isSuccess} = useCategoryForms(categoryId)
    const {paperlessNavigate} = usePaperlessNavigate();
    const location = useLocation()
    const [formAtom, setFormAtom] = useAtom(createFormAtom);
    const activeCategoryForms = useMemo(() => data?.filter(c => c.activeStatus), [data])

    const handleNavigation = (form) => {
        setFormAtom({
            ...formAtom,
            formTypeId: form.formTypeId
        })
        paperlessNavigate({
            destination: `/forms/${form.formTypeId}/fields`,
            payload: form.formTypeName
        })
    }

    if (isError && error.code === 'ERR_NETWORK') {
        return (
            <NetworkError error={error}/>
        )
    }

    return (
        <>
            <p className={'page-title'}>{location.state}</p>
            {isSuccess && <div className={'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-8'}>
                {activeCategoryForms.map((f, i) =>
                    <button type={'button'} key={f.formTypeId} className={'block'}
                            onClick={() => handleNavigation(f)}>
                        <Card description={f.description} title={f.formTypeName}/>
                    </button>
                )}
            </div>}

            {isLoading && <Loader className={'fixed inset-0'}/>}

            {(!data?.length || !activeCategoryForms?.length) && <div className={'flex flex-col items-center mt-16'}>
                <NoData className={'w-64 h-64 text-[#0A0D36]'}/>
                <p className={'p-4 font-medium text-lg text-gray-600'}>There are no forms under this category. Kindly
                    contact management</p>
                <button type={'button'}
                        className={'block w-96 p-1.5 text-white bg-[#0A0D36] inline-flex justify-center items-center space-x-2'}
                        onClick={() => paperlessNavigate({destination: '/', payload: ''})}>
                    <MdKeyboardBackspace/>
                    <span> Home </span>
                </button>
            </div>}
        </>
    )
};

export default CategoryForms;